import React, { Component } from 'react';
import OTSalesView from './OTSalesView';
import css from './ApxView.module.css';
import cssMain from './Main.module.css';
import { OTModules } from '../Enums/Enums';
import DefaultView from './DefaultView';
import OTSupportView from './OTSupportView';
import VerticalNavigationOT from '../Components/VerticalNavigationOT';

class OTView extends Component {
  constructor(props) {
    super(props);

    this.props.data.OTModuleCallback = this.verticalMenuChange.bind(this);
    this.handleChangeValue = this.handleChangeValue.bind(this);
    this.navigationHasItems = false;
    this.currentview = OTModules.Default;

    this.state = {
      moduleView: OTModules.Default
    }
  }

  handleChangeValue(items) {
    this.navigationHasItems = items.length > 0;
    if (this.navigationHasItems)
      this.setState({ moduleView: items[0].value });
  }
  
  verticalMenuChange(value, index) {
    this.setState({ moduleView: value });
  }

  render() {
    return (
      <div style={{ width: "100%", height: "calc(100vh - 100px)" }}>
        <div className={css.vertical_menu}>
          <VerticalNavigationOT data={this.props.data} getItemList={this.handleChangeValue} items={[{ text: "Sales", value: "OTSales", isActive: true },{ text: "Support", value: "OTSupport"} ]}></VerticalNavigationOT>
        </div>
       <div className={cssMain.scroll_area}>
          {(this.state.moduleView === OTModules.Default) ? <DefaultView></DefaultView> : null}
          {(this.state.moduleView === OTModules.Sales) ? <OTSalesView data={this.props.data}></OTSalesView> : null}
          {(this.state.moduleView === OTModules.Support) ? <OTSupportView data={this.props.data}></OTSupportView> : null}
        </div>
     </div>
    );
  }
}

export default OTView;